<template>
  <ts-loading-banner :loading="loading">
    <div
      class="ts-border ts-border-gray-500 ts-border-dashed ts-rounded-md ts-p-4 ts-relative ts-h-full"
    >
      <div class="ts-uppercase ts-font-semibold form-badge">
        {{ $t('paymentAdjustment.form') }}
      </div>
      <div class="row">
        <div class="col-md-6 ts-space-y-2">
          <div class="row">
            <label class="col-form-label col-md-4 required ts-text-right">{{
              $t('paymentAdjustment.date')
            }}</label>
            <div class="col-md-8">
              <a-date-picker
                :style="{ width: '100%' }"
                format="DD-MM-YYYY"
                valueFormat="DD-MM-YYYY"
                v-model="model.adj_date"
              />
              <div class="validate" v-if="errors.has('adj_date')">
                {{ errors.first('adj_date') }}
              </div>
            </div>
          </div>
          <div class="row">
            <label class="col-form-label col-md-4 required ts-text-right">{{
              $t('paymentAdjustment.adjustmentAmount')
            }}</label>
            <div class="col-md-8">
              <input class="form-control" v-model.number="model.adj_amount" />
              <div class="validate" v-if="errors.has('adj_amount')">
                {{ errors.first('adj_amount') }}
              </div>
            </div>
          </div>
          <div class="row">
            <label class="col-form-label col-md-4 required ts-text-right">{{
              $t('paymentAdjustment.newClass')
            }}</label>
            <div class="col-md-8">
              <a-select
                v-model.number="model.new_class_id"
                style="width:100%"
                :showSearch="true"
                :options="classes"
                :filterOption="
                  (input, option) =>
                    option.componentOptions.children[0].text
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                "
                optionFilterProp="children"
                @change="onNewClassChange"
              />
              <div class="validate" v-if="errors.has('new_class_id')">
                {{ errors.first('new_class_id') }}
              </div>
            </div>
          </div>
          <div class="row">
            <label class="col-form-label col-md-4 ts-text-right required">{{
              $t('paymentAdjustment.description')
            }}</label>
            <div class="col-md-8">
              <textarea
                v-model="model.descriptions"
                class="form-control"
                rows="5"
              ></textarea>
              <div class="validate" v-if="errors.has('descriptions')">
                {{ errors.first('descriptions') }}
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-6 ts-space-y-2">
          <div class="row">
            <label class="col-form-label col-md-4 required ts-text-right">{{
              $t('paymentAdjustment.invoice')
            }}</label>
            <div class="col-md-8">
              <div
                class="ts-w-full ts-border ts-roundeds ts-h-8 ts-flex ts-items-center ts-px-2 ts-rounded"
              >
                <b>{{ invoice.inv_number }}</b>
              </div>
              <div class="validate" v-if="errors.has('inv_id')">
                {{ errors.first('inv_id') }}
              </div>
            </div>
          </div>
          <div class="row">
            <label class="col-form-label col-md-4 required ts-text-right">{{
              $t('paymentAdjustment.invoiceAmount')
            }}</label>
            <div class="col-md-8">
              <input
                class="form-control"
                v-model.number="model.new_inv_amount"
                readonly
              />
              <div class="validate" v-if="errors.has('new_inv_amount')">
                {{ errors.first('new_inv_amount') }}
              </div>
            </div>
          </div>
          <div class="row">
            <label class="col-form-label col-md-4 required ts-text-right">{{
              $t('paymentAdjustment.acProgram')
            }}</label>
            <div class="col-md-8">
              <div class="ts-border ts-rounded ts-p-1">
                <ul>
                  <li class="ts-border-l-2 ts-border-gray-400">
                    <span class="ts-ml-2">{{ invoice.acp_name_foreign }}</span>
                    <ul class="ts-ml-2">
                      <li class="ts-border-l-2 ts-border-gray-400">
                        <span class="ts-ml-2">{{
                          invoice.acps_name_foreign
                        }}</span>
                        <ul class="ts-ml-2">
                          <li class="ts-border-l-2 ts-border-gray-400">
                            <span class="ts-ml-2">{{
                              invoice.level_name_foreign
                            }}</span>
                            <ul class="ts-ml-2">
                              <li class="ts-border-l-2 ts-border-gray-400">
                                <span class="ts-ml-2">{{
                                  invoice.grade_name_foreign
                                }}</span>
                                <ul class="ts-ml-2">
                                  <li class="ts-border-l-2 ts-border-gray-400">
                                    <span class="ts-ml-2">{{
                                      invoice.term_name
                                    }}</span>
                                    <ul class="ts-ml-2">
                                      <li
                                        class="ts-border-l-2 ts-border-gray-400"
                                      >
                                        <span
                                          class="ts-ml-2 ts-text-blue-800"
                                          >{{ invoice.class_name }}</span
                                        >
                                      </li>
                                    </ul>
                                  </li>
                                </ul>
                              </li>
                            </ul>
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ts-loading-banner>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapActions } from 'vuex'
export default {
  name: 'formAdjustmentV2',
  props: ['value', 'invoice', 'validate'],
  data() {
    return {
      errors: new Errors(),
      loading: false,
      classes: [],
      model: {}
    }
  },

  created() {
    this.model = this.value
  },
  methods: {
    ...mapActions('paymentAdjustment', ['formViewModel']),
    fetchNewClass(acpId) {
      this.model.new_class_id = ''
      this.classes = []
      this.loading = true
      return this.formViewModel({
        fnName: 'academicClass',
        acp_id: acpId
      })
        .then(response => {
          this.classes = response.academicClass.map(el => ({
            value: el.class_id,
            label:
              el.class_name +
              '|' +
              el.class_desc +
              '|' +
              el.fname_foreign +
              ' ' +
              el.lname_foreign,
            obj: el
          }))
        })
        .finally(() => (this.loading = false))
    },
    fetchEnrollClass(studentId, classId) {
      this.loading = true
      return this.formViewModel({
        fnName: 'enrollExisting',
        student_id: studentId,
        class_id: classId
      })
        .then(response => {
          if (!response.enrollExisting) {
            this.model.student_id = this.invoice.student_id
            this.model.need_enroll = true
          }
        })
        .finally(() => (this.loading = false))
    },
    onNewClassChange(value, props) {
      let param = {
        ...props.data.props.obj,
        student_id: this.invoice.student_id
      }
      this.$parent.$refs.invoiceDetail.fetchItemDetail(param)
      this.fetchEnrollClass(param)
    }
  },
  watch: {
    validate: function(error) {
      this.errors = new Errors(error.errors)
    }
  }
}
</script>

<style scoped>
.form-badge {
  background: #075276e0;
  width: fit-content;
  padding: 3px 7px;
  color: white;
  border-radius: 4px;
  display: flex;
  align-items: center;
  box-shadow: 0 8px 5px -2px #0000002e;
  position: absolute;
  top: 0;
  left: 0;
  margin-top: -12px;
  margin-left: 23px;
}
</style>
